import { defineComponent as _defineComponent } from 'vue'
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import CcModal from '@/views/Automation/CampaignCreatorV2/components/Modals/CcModal.ts.vue';
import { CardLayer } from '@/views/Automation/CampaignCreatorV2/types';
import { api } from '@sh/services/api';
import { computed, ref } from 'vue';

interface Props {
  isModalOpen: boolean;
  modalTitle?: string;
  featureId: string;
}

interface Emits {
  (event: 'onCancel'): void;
  (event: 'onSave'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcRequestFeatureModal.ts',
  props: {
    isModalOpen: { type: Boolean },
    modalTitle: null,
    featureId: null
  },
  emits: ["onCancel", "onSave"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'onCancel'): void;
  (event: 'onSave'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isModalOpen: boolean;
  modalTitle?: string;
  featureId: string;
};





const text = ref<string>('');

const disabledMessage = computed(() => {
  if (!text.value) {
    return 'Please complete the field to submit.';
  }

  return '';
});

async function onSaveClick() {
  emits('onSave');

  try {
    await api.campaignCreator.createFeatureRequest({ description: text.value, featureId: props.featureId });
  } catch (error) {
    // TODO: Add proper error handling (notification on top right ?)
    console.log('Failed saving feature', error);
  }
  text.value = '';
}

function onModalClose() {
  text.value = '';
  emits('onCancel');
}

return { __sfc: true,props, emits, text, disabledMessage, onSaveClick, onModalClose, CcCardItem, CcModal, CardLayer }
}

})